import {useParams} from 'react-router-dom';
import {useState, createContext, useContext} from 'react';
import {initializeExternalWallet} from 'api/routes/wallet';
import {getError} from 'utils/helpers';

export const STEPS = {
    POCKET_ID_VERIFICATION: 'Pocket_Id',
    WAITING_FOR_PAYMENT: 'WaitingForPayment',
};

export const PayWithPocketContext = createContext({});
export const usePayWithPocket = () => useContext(PayWithPocketContext);

export const PayWithPocketProvider = ({checkoutData = {}, children}) => {
    const [currentState, setCurrentState] = useState(STEPS.POCKET_ID_VERIFICATION);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const [pocket_tag, setPocketTag] = useState('');

    const {reference} = useParams();

    const {metadata, API, apiVersion} = checkoutData;
    const Authorization = metadata?.merchant?.publicKey;
    const config = {headers: {Authorization}};

    const updateCurrentState = newState => {
        setLoading(false);
        setErrorMsg('');
        setCurrentState(newState);
    };

    const handleChange = phone => {
        setPocketTag(phone);
        updateError('pocket_tag');
    };

    const updateError = name => {
        setFormErrors(prev => ({
            ...prev,
            [name]: '',
        }));
    };

    const handleError = message => {
        setLoading(false);
        setErrorMsg({msg: message});
    };

    const initializePayment = async () => {
        try {
            setLoading(true);
            setErrorMsg();

            const response = await API.put(
                `${apiVersion}${initializeExternalWallet(reference, 'pocket')}`,
                {pocket_tag},
                config
            );

            const {status, data} = response || {};

            if ((status === 201 || status === 200) && (data.status || data.success)) {
                updateCurrentState(STEPS.WAITING_FOR_PAYMENT);
            } else handleError(data?.message);
        } catch (error) {
            handleError(getError(error.response.data));
        }
    };

    return (
        <PayWithPocketContext.Provider
            value={{
                currentState,
                loading,
                errorMsg,
                formErrors,
                pocket_tag,
                handleChange,
                initializePayment,
                checkoutData,
            }}
        >
            {children}
        </PayWithPocketContext.Provider>
    );
};
